import { DEFAULT_PAGE } from "../../contstants";
import getDateRange from "../../utils/getDateRange";
import { GetVoidCards } from "./getVoidCards";

const FilterVoidCards = async (perPage, filters) => {
  const page = filters.page || DEFAULT_PAGE;
  const prn = filters?.search_in_fields === 'prn' ? filters.s : "";
  const created_by = filters?.search_in_fields === 'user' ? filters.s : "";
  const office_id = filters?.office_id ?? "";
  const { dateFrom, dateTo } = getDateRange(filters.date);

  return await GetVoidCards({
    limit: perPage,
    offset: (page - 1) * perPage,
    prn,
    created_by,
    office_id,
    dateFrom,
    dateTo
  });
};

export default FilterVoidCards;
